import { render, staticRenderFns } from "./AdminNadzornoLice.vue?vue&type=template&id=8db49ede&"
import script from "./AdminNadzornoLice.vue?vue&type=script&lang=js&"
export * from "./AdminNadzornoLice.vue?vue&type=script&lang=js&"
import style0 from "./AdminNadzornoLice.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports